import { initialLaboratoriesState } from 'redux/initialStates';
import { status } from 'constants/general';
import laboratoriesActionTypes from './action-types';

const laboratoriesReducer = (state = initialLaboratoriesState, { type, payload }) => {
  switch (type) {
    case laboratoriesActionTypes.FETCH_ALL_LABS_WITH_FILTERS:
      return {
        ...state,
        laboratoriesList: {
          status: status.FETCHING,
        },
      };
    case laboratoriesActionTypes.FETCH_ALL_LABS_WITH_FILTERS_SUCCESS:
      return {
        ...state,
        laboratoriesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case laboratoriesActionTypes.FETCH_ALL_LABS_WITH_FILTERS_FAIL:
      return {
        ...state,
        laboratoriesList: {
          status: status.FAIL,
        },
      };
    case laboratoriesActionTypes.FETCH_ADD_LAB_SUBMISSION:
      return {
        ...state,
        addLab: {
          status: status.FETCHING,
        },
      };
    case laboratoriesActionTypes.FETCH_ADD_LAB_SUBMISSION_SUCCESS:
      return {
        ...state,
        addLab: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case laboratoriesActionTypes.FETCH_ADD_LAB_SUBMISSION_FAIL:
      return {
        ...state,
        addLab: {
          status: status.FAIL,
        },
      };
    default:
      return state;
  }
};

export default laboratoriesReducer;
